import { FC, useEffect, useState } from 'react';
import translation from '../../languages';
import { starsTitles } from './star-rating.constants';
import PointyStar from './components/pointy-star';
import './star-rating.scss';

type StarRatingProps = TranslationProps & {
    fillColor: string;
    borderColor?: string;
    emptyColor?: string;
    height?: number;
    maxValue?: number;
    onChangeHover?: (value: number) => void;
    onChangeValue?: (value: number) => void;
    ratingValue?: number;
    readOnly?: boolean;
    showTooltip?: boolean;
    width?: number;
    viewBox?: string;
};

const StarRating: FC<StarRatingProps> = ({ t, ...props }) => {
    const [rating, setRating] = useState<number>(props.ratingValue ?? 0);
    const [hover, setHover] = useState<number>(0);

    useEffect(() => setRating(props.ratingValue ?? 0), [props.ratingValue]);

    const onSetRating = (e: React.MouseEvent<HTMLDivElement>) => {
        if (props.readOnly) {
            return;
        }

        const value = Number(e.currentTarget.dataset.rating);

        setRating(value);
        if (props.onChangeValue) {
            props.onChangeValue(value);
        }
    };

    const onSetHover = (e: React.MouseEvent<HTMLDivElement>) => {
        if (props.readOnly) {
            return;
        }

        const value = e.type === 'mouseleave' ? 0 : Number(e.currentTarget.dataset.rating);

        setHover(value);
        if (props.onChangeHover) {
            props.onChangeHover(value);
        }
    };

    return (
        <div className='star-rating'>
            {[...Array(props.maxValue)].map((star, index) => {
                const starId = index + 1;
                const showTooltip = !props.readOnly && props.showTooltip && starsTitles?.[starId];

                return (
                    <PointyStar
                        key={starId}
                        index={starId}
                        rating={rating}
                        hover={hover}
                        onChangeValue={onSetRating}
                        onChangeHover={onSetHover}
                        height={props.height}
                        width={props.width}
                        tooltip={showTooltip && t(starsTitles?.[starId])}
                    />
                );
            })}
        </div>
    );
};

const translate = translation('material-feedbacks');

export default translate(StarRating);
